module.exports = __webpack_public_path__ + "media/images/nextdayblinds_permitapp-8e707c30.jpg";